import React from "react";
import {ListItem, Paragraph, PolicyTitle, SubHeading} from "../PrivacyPolicyText";

const BiometricPrivacySection = () => (
  <>
    <PolicyTitle>{"BIOMETRIC PRIVACY POLICY"}</PolicyTitle>

    <Paragraph>{"The Company has instituted the following biometric information privacy Policy:"}</Paragraph>

    <SubHeading>{"Biometric Data Defined"}</SubHeading>

    <Paragraph>
      {"As used in this Policy, biometric data includes “biometric identifiers” and “biometric information” as defined in the Illinois Biometric Information Privacy Act, 740 ILCS § 14/1, et seq. “Biometric identifier” means a retina or iris scan, fingerprint, voiceprint, or scan of hand or face geometry. Likewise, this Policy applies to the Texas Capture and Use of Biometric Identifier Act (“CUBI”) and the biometric protection laws of the State of Washington. Biometric identifiers do not include writing samples, written signatures, photographs, human biological samples used for valid scientific testing or screening, demographic data, tattoo descriptions, or physical descriptions such as height, weight, hair color, or eye color. Biometric identifiers do not include information captured from a patient in a health care setting or information collected, used, or stored for health care treatment, payment, or operations under the federal Health Insurance Portability and Accountability Act of 1996. “Biometric information” means any information, regardless of how it is captured, converted, stored, or shared, based on an individual’s biometric identifier used to identify an individual. Biometric information does not include information derived from items or procedures excluded under the definition of biometric identifiers."}
    </Paragraph>

    <SubHeading>{"Purpose for Collection of Biometric Data"}</SubHeading>

    <Paragraph>
      {"The Company and/or its vendors, may collect biometric data for purposes of the Services to be provided, including, but not limited to, identification of users and confirming identity of any party using the Services provided."}
    </Paragraph>

    <SubHeading>{"Disclosure and Authorization"}</SubHeading>

    <Paragraph>
      {"To the extent that the Company or its vendors, capture, or otherwise obtain biometric data relating to a user, the Company must first:"}
    </Paragraph>

    <ListItem marker="(a)">
      {"Inform the user in writing that the Company and its vendors, are collecting, capturing, or otherwise obtaining the user’s biometric data, and that the Company is providing such biometric data to its vendors;"}
    </ListItem>

    <ListItem marker="(b)">
      {"Inform the users in writing of the specific purpose and length of time for which the user’s biometric data is being collected, stored, and used; and"}
    </ListItem>

    <ListItem marker="(c)" withBottomMargin>
      {"Receive a written release acknowledged and executed by the user (or his or her legally authorized representative) authorizing the Company and its vendors to collect, store, and use the user’s biometric data for the specific purposes disclosed by the Company, and for the Company to provide such biometric data to its vendors."}
    </ListItem>

    <Paragraph>
      {"The Company and its vendors will not sell, lease, trade, or otherwise profit from users’ biometric data."}
    </Paragraph>

    <SubHeading>{"Disclosure"}</SubHeading>

    <Paragraph>
      {"The Company will not disclose or disseminate any biometric data to anyone other than its vendors providing products and services using biometric data without/unless:"}
    </Paragraph>

    <ListItem marker="(a)">{"First obtaining written user consent to such disclosure or dissemination;"}</ListItem>

    <ListItem marker="(b)">
      {"The disclosed data completes a financial transaction requested or authorized by the user;"}
    </ListItem>

    <ListItem marker="(c)">{"Disclosure is required by state or federal law or municipal ordinance; or"}</ListItem>

    <ListItem marker="(d)" withBottomMargin>
      {"Disclosure is required pursuant to a valid warrant or subpoena issued by a court of competent jurisdiction."}
    </ListItem>

    <SubHeading>{"Retention Schedule"}</SubHeading>

    <Paragraph>
      {"The Company shall retain user’s biometric data only until, and shall request that its vendors permanently destroy such data when, the first of the following occurs:"}
    </Paragraph>

    <ListItem>
      {"The initial purpose for collecting or obtaining such biometric data has been satisfied, such as the termination of the business relationship with User; or"}
    </ListItem>

    <ListItem withBottomMargin>
      {"Within 3 years of the User's last interaction with the Company, unless a shorter period is required by law."}
    </ListItem>

    <SubHeading>{"Data Storage"}</SubHeading>

    <Paragraph>
      {"The Company shall use a reasonable standard of care to store, transmit and protect from disclosure any paper or electronic biometric data collected. Such storage, transmission, and protection from disclosure shall be performed in a manner that is the same as or more protective than the manner in which the Company stores, transmits and protects from disclosure other confidential and sensitive information, including personal information that can be used to uniquely identify an individual or an individual’s account or property, such as genetic markers, genetic testing information, account numbers, PINs, driver’s license numbers and social security numbers."}
    </Paragraph>
  </>
);

export default BiometricPrivacySection;
